import { MotionInstanceBindings } from "@vueuse/motion";
import { difference } from "lodash";

const getRandomX = () => Phaser.Math.Between(-window.innerWidth, window.innerWidth);
const getRandomY = () => Phaser.Math.Between(-window.innerHeight, window.innerHeight);
const getCenterX = () => window.innerWidth / 2;
const getCenterY = () => window.innerHeight / 2;

type Variant = 'up' | 'down' | 'shrink' | 'grow' | 'scatter' | 'collect';

const getGameSetTransitions = (index: number, opts: {
    onComplete?: Function,
    variants?: { [key:string]: any }
} = {}) => {
    return {
        delay: 25 * index,
        initial: {
            opacity: 0,
            scale: 1,
            y: 300,
            x: 0
        },
        enter: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 500,
                ease: 'easeOut',
                onComplete: () => opts.onComplete?.(index)
            }
        },
        variants: {
            'up': {
                opacity: 0,
                y: -300,
                transition: {
                    delay: (25 - index) * index,
                    duration: 225,
                    ease: 'easeIn'
                },
            },
            // 'down': {
            //     opacity: 0,
            //     y: 300,
            //     transition: {
            //         delay: 25 * index,
            //         duration: 250,
            //         ease: 'easeOut'
            //     },
            // },
            'shrink': {
                opacity: 0,
                scale: 0,
                transition: {
                    delay: (25 - index) * index,
                    duration: 225,
                    ease: 'easeIn'
                },
            },
            'grow': {
                opacity: 0,
                scale: 3,
                transition: {
                    delay: (25 - index) * index,
                    duration: 225,
                    ease: 'easeIn'
                },
            },
            'scatter': {
                opacity: 0,
                x: getRandomX(),
                y: getRandomY(),
                transition: {
                    duration: 500,
                    ease: 'easeIn'
                },
            }
        }
    }
}


const getCenterVariant = (target: HTMLElement) => {
    let [centerX, centerY] = [getCenterX(), getCenterY()];
    let rect = target.getBoundingClientRect();
    return {
        opacity: 0,
        x: centerX - (rect.left + (rect.width / 2)),
        y: centerY - (rect.top + (rect.height / 2)),
        transition: {
            duration: 400,
            ease: 'easeIn'
        },
    }
}

let AllVariants : Variant[] = ['up', 'scatter', 'collect', 'grow', 'shrink'];

const gameSetLeave = (motions: MotionInstanceBindings<any>, excludeVariants: Variant[] = []) => {
    const variations = difference(AllVariants, excludeVariants);
    const transitionName = Phaser.Utils.Array.GetRandom(variations);
    let proms : Promise<void[]>[] = [];
    for (let key in motions){
        // let f = motions[key];
        let target = <HTMLElement> motions[key].target
        let variant = transitionName === 'collect' ? getCenterVariant(target) : transitionName;
        let prom = motions[key].apply(variant);
        if (prom) proms.push(prom);
    }
    return Promise.all(proms);
}

export {
    getGameSetTransitions,
    gameSetLeave,
    getCenterVariant,
    getCenterX,
    getCenterY,
    getRandomX,
    getRandomY
}